import * as React from "react";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import CalendarToday from "@material-ui/icons/CalendarToday";
import Edit from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import CurrencyNumber from "./CurrencyNumber";
import PercentageNumber from "./PercentageNumber";
import { formatDate } from "../../utilities/format";
import RRoR from "./RRoR";
import { RemoveHouseholdModal } from "../../containers/Dashboard/components";

const styles = (theme) => ({
  card: {
    backgroundColor: theme.palette.grey[50],
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    marginBottom: 20,
  },
  row: {
    marginBottom: "2%",
    whiteSpace: "nowrap",
  },
  dateRow: {
    borderTop: `1px solid ${theme.palette.grey["A100"]}`,
    margin: "3% 0",
    padding: "3% 0 0 0",
  },
  icon: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: "50px",
    padding: "2px 4px",
    color: theme.palette.primary.main,
  },
  data: {
    display: "inline-block",
    verticalAlign: "middle",
    fontSize: "13px",
    "& svg": {
      fontSize: "16px",
      verticalAlign: "middle",
    },
  },
  value: {
    paddingLeft: "5%",
  },
  tag: {
    width: "100%",
    textAlign: "center",
    backgroundColor: theme.palette.grey[300],
    padding: "6px",
    fontSize: "14.7px",
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  wrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  box1: {
    padding: "2% 6% 0 6%",
  },
  box2: {
    padding: "0 6% 0 6%",
  },
  box3: {
    backgroundColor: theme.palette.grey[200],
    padding: "3% 0",
  },
  item: {
    width: "33%",
    fontSize: "13px",
    margin: "0 auto",
    textAlign: "center",
    "&:nth-child(2n)": {
      borderLeft: `1px solid ${theme.palette.grey["A100"]}`,
      borderRight: `1px solid ${theme.palette.grey["A100"]}`,
    },
  },
  boxLabel: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  actionBtn: {
    fontSize: "13px",
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
    "& svg": {
      fontSize: "12px",
    },
  },
});

const HouseholdCard = ({ fields, householdDetails, classes, adminView }) => {
  return (
    <Card className={classes.card}>
      <Grid container>
        <Grid item className={classes.tag}>
          Household
        </Grid>
        <Grid item className={classes.wrapper}>
          <div className={classes.box1}>
            {fields
              .filter(([icon, value]) => value) // value must be non-empty string
              .map(([icon, value]) => (
                <div className={classes.row} key={value}>
                  <div className={`${classes.data} ${classes.icon}`}>
                    {icon}
                  </div>
                  <div className={`${classes.data} ${classes.value}`}>
                    {value}
                  </div>
                </div>
              ))}
          </div>
          <div className={classes.box2}>
            <div className={classes.dateRow}>
              <div className={`${classes.data} ${classes.icon}`}>
                <CalendarToday />
              </div>
              <div className={`${classes.data} ${classes.value}`}>
                {formatDate(householdDetails.createdAt)}
              </div>
            </div>
            {!adminView && (
              <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
              >
                <Link to={`/Portal/household/${householdDetails.id}/client`}>
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    className={classes.actionBtn}
                  >
                    <Edit />
                    Edit
                  </Button>
                </Link>
                <RemoveHouseholdModal
                  household={householdDetails}
                  className={classes.actionBtn}
                />
              </Grid>
            )}
          </div>
          <Grid container className={classes.box3}>
            <Grid item className={classes.item}>
              <div className={classes.boxLabel}>RRoR</div>
              <RRoR rrorValue={householdDetails.rror} />
            </Grid>
            <Grid item className={classes.item}>
              <div className={classes.boxLabel}>Loss</div>
              <PercentageNumber value={householdDetails.risk} showSign />
            </Grid>
            <Grid item className={classes.item}>
              <div className={classes.boxLabel}>Household Assets</div>
              <CurrencyNumber value={householdDetails.initialInvestment} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default withStyles(styles)(HouseholdCard);



// WEBPACK FOOTER //
// ./src/components/UI/HouseholdCard.jsx